import { AxiosRequestConfig } from 'axios'
import jwtDecode from 'jwt-decode'

export class TokenStorage {
  public static isAuthenticated(): boolean {
    const token = this.getToken()
    return !!token && !this.isTokenExpired(token)
  }

  public static getAuthentication(): AxiosRequestConfig {
    return {
      headers: { Authorization: 'Bearer ' + this.getToken() }
    }
  }

  public static getNewToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      // axios
      //   .post(
      //     '/refresh',
      //     {},
      //     { headers: { Authorization: 'Bearer ' + this.getRefreshToken() } }
      //   )
      //   .then(response => {
      //     this.storeToken(response.data.access_token)
      //     this.storeRefreshToken(response.data.refresh_token)
      //
      //     resolve(response.data.access_token)
      //   })
      //   .catch(error => {
      //     reject(error)
      //   })
    })
  }

  public static storeToken(token: string): void {
    localStorage.setItem(TokenStorage.LOCAL_STORAGE_TOKEN, token)
  }

  public static storeRefreshToken(refreshToken: string): void {
    localStorage.setItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN, refreshToken)
  }

  public static clear(): void {
    localStorage.removeItem(TokenStorage.LOCAL_STORAGE_TOKEN)
    localStorage.removeItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN)
  }

  public static getToken(): string | null {
    return localStorage.getItem(TokenStorage.LOCAL_STORAGE_TOKEN)
  }

  private static readonly LOCAL_STORAGE_TOKEN = 'token'
  private static readonly LOCAL_STORAGE_REFRESH_TOKEN = 'refresh_token'

  public static getRefreshToken(): string | null {
    return localStorage.getItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN)
  }

  private static isTokenExpired(token: string): boolean {
    try {
      const decoded = jwtDecode(token)

      // @ts-ignore
      return Date.now() / 1000 >= decoded.exp
    } catch (err) {
      console.log('expired check failed!, TokenStorage')
      TokenStorage.clear()
      return false
    }
  }
}
